import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Text, Box, Select } from 'core/components';
import { KMI_RANK_TYPES } from 'app/util/constants';

function valueRenderer(option) {
  return (
    <Box>
      <Text as="div" fontSize="small" color="muted" pb="1px">
        Ranking Type
      </Text>
      <Text as="div" fontWeight="bold" fontSize="small">
        {option?.label}
      </Text>
    </Box>
  );
}

@observer
class CustomerTypeFilter extends Component {
  render() {
    const { onChange, defaultFilter, filterProps = {}, disabled, ...rest } = this.props;
    const { rank_type } = defaultFilter;
    const { excludeOptions = [] } = filterProps;
    const options = KMI_RANK_TYPES.asArray().filter((type) => !excludeOptions.includes(type.value));

    return (
      <Box {...rest}>
        <Select
          options={options}
          values={rank_type}
          valueRenderer={valueRenderer}
          onChange={(option) => onChange({ rank_type: option })}
          menuWidth={200}
          disabled={disabled}
        />
      </Box>
    );
  }
}

export default CustomerTypeFilter;
